module.exports = __webpack_public_path__ + "static/media/M1-26-Halfdan-Galadris-cod135.d5203272.png";